import type { FetchThemePageProps } from '~/types/themePage';

import { useThemePageV6Query } from '~/api/gempages/queries/useThemePageV6Query';
import { useTemplateIdV6Parser } from '~/modules/campaign-template';
import { useThemePageStore } from '~/stores/themePage';
import { mapThemePagesV6 } from '~/utils';
import { useMemo } from 'react';

export const useQueryThemePagesV6 = (props?: FetchThemePageProps) => {
  const { templateIdV6WithAsset, templateIdV6WithVariant } = useTemplateIdV6Parser(props);
  const upsertThemePages = useThemePageStore((state) => state.upsertThemePages);
  const setIdsFetched = useThemePageStore((state) => state.setIdsFetched);

  const templateIds = useMemo(() => {
    if (props?.assets) {
      return templateIdV6WithAsset;
    }

    if (props?.campaigns) {
      return templateIdV6WithVariant;
    }
    return [];
  }, [props?.assets, props?.campaigns, templateIdV6WithAsset, templateIdV6WithVariant]);

  useThemePageV6Query(
    {
      where: {
        idIn: templateIds,
      },
    },
    {
      enabled: !!templateIds?.length,
      onSuccess: (response) => {
        if (!templateIds?.length) return;

        const themePages = mapThemePagesV6(response);
        upsertThemePages(themePages);
        setIdsFetched(templateIds);
      },
    },
  );
};
